import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import aboutHero from "@/assets/about-hero.jpg";

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO title="About Us" description="Learn about Plymhair — your premium hair destination in Plymouth. Quality wigs, extensions, braids and more." url="/about" />
      <Navbar />

      {/* Hero banner with image */}
      <section className="relative h-[50vh] min-h-[400px] overflow-hidden">
        <img
          src={aboutHero}
          alt="Inside the Plymhair boutique"
          className="absolute inset-0 w-full h-full object-cover"
          width={1920}
          height={800}
        />
        <div className="absolute inset-0 bg-foreground/60" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
          <h1 className="font-display text-5xl md:text-7xl text-primary-foreground mb-4">
            About <span className="italic font-normal">Us</span>
          </h1>
          <p className="font-body text-primary-foreground/80 text-lg">
            A little bit of our story.
          </p>
        </div>
      </section>

      {/* Story content */}
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6">
          <p className="font-body text-muted-foreground uppercase tracking-widest text-sm mb-3">
            About Company
          </p>
          <h2 className="font-display text-3xl md:text-4xl text-foreground mb-8 leading-tight">
            Finding Your Perfect Hair Match: The Plymhair Story
          </h2>

          <div className="space-y-6 font-body text-foreground/80 text-base md:text-lg leading-relaxed">
            <p>
              Plymhair was born from a frustration familiar to many women: the
              struggle to find quality hair extensions that truly reflected their
              individual style and needs.
            </p>
            <p>
              In 2005, two sisters relocated from Bradford to Plymouth, eager to
              express themselves through their hair. Disappointed by the limited
              options available, they began importing hair from around the world,
              determined to find the perfect match.
            </p>
            <p>
              This experience sparked a passion to help others. In 2008, they
              launched a mobile hair service, listening to the challenges faced
              by a diverse clientele. They discovered a widespread desire for
              more variety in hair extensions – colours beyond blonde and
              brunette, luxurious textures, and top-tier quality.
            </p>
            <p>
              Most importantly, they encountered women experiencing medical hair
              loss due to conditions like cancer or alopecia. Finding extensions
              that matched their natural hair and complemented their personal
              style proved particularly difficult.
            </p>
            <p>
              Fuelled by this understanding, Plymhair opened its doors in
              Plymouth in 2015. Our mission: to empower women of all backgrounds
              by providing a personalised approach to hair extensions and wigs.
              We offer a wide selection of high-quality products sourced from the
              best global suppliers, ensuring you find the perfect match for your
              unique needs.
            </p>
            <p>
              Plymhair's services extend beyond just supplying hair. Our expert
              team provides installation and braiding services for a seamless
              experience. For those seeking a truly bespoke solution, we offer
              personalised consultations by appointment.
            </p>
            <p className="text-foreground font-semibold italic text-lg md:text-xl">
              At Plymhair, we understand the transformative power of feeling
              confident in your hair. Let us help you find your perfect match.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
